import React from 'react';
import googleLogo from 'src/assets/images/google-ico.svg';
import { Button } from '@material-ui/core';
import { useStyles } from './styles';

export const GoogleButton: React.FC<any> = (props) => {
  const classes = useStyles();
  return (
    <Button className={classes.root} variant="outlined" {...props}>
      <img src={googleLogo} className={classes.img} alt="Google" />
      <span className={classes.text}>Google</span>
    </Button>
  );
};
